import createReducer from '../../../store/createReducer';
import { normalizeArray } from '../../../utils/reducerUtils';
import SPEAKERS from '../../../mocks/speakers';

import { FETCH_SPEAKERS_SUCCESS, FETCH_SPEAKERS_REQUEST } from '../actions/speakersActions';

function fetchSpeakersSuccess(state, action) {
    return {
        ...state,
        speakers: action.payload,
        speakersById: normalizeArray(action.payload),
        fetchingSpeakers: false
    };
}

function fetchSpeakersRequest(state) {
    return {
        ...state,
        fetchingSpeakers: true
    };
}

export const initialState = {
    fetchingSpeakers: false,
    speakers: SPEAKERS,
    speakersById: normalizeArray(SPEAKERS)
};

export default createReducer(initialState, {
    [FETCH_SPEAKERS_SUCCESS]: fetchSpeakersSuccess,
    [FETCH_SPEAKERS_REQUEST]: fetchSpeakersRequest
});
